import { Flex, Icon, Stack, Text } from "@chakra-ui/react";
import type { IconType } from "react-icons";
import { FiInbox } from "react-icons/fi";
import { useTranslation } from "react-i18next";

interface Props {
  title?: string;
  description?: string;
  icon?: IconType;
}

// Shared read-only empty state for document lists. Callers pass context-specific copy; the layout
// (soft icon badge + bold title + muted subtitle) stays consistent everywhere.
export const DocumentsEmptyState = ({ title, description, icon = FiInbox }: Props) => {
  const { t } = useTranslation();
  return (
    <Flex direction="column" align="center" justify="center" textAlign="center" gap="3" py="12">
      <Flex boxSize="16" rounded="2xl" bg="smBackgroundSecondary" align="center" justify="center">
        <Icon as={icon} boxSize="7" color="smMuted" />
      </Flex>
      <Stack spacing="1" maxW="sm">
        <Text fontWeight="semibold" color="smText">
          {title ?? t("No documents uploaded")}
        </Text>
        {description && (
          <Text fontSize="sm" color="smMuted">
            {description}
          </Text>
        )}
      </Stack>
    </Flex>
  );
};
